/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable react/self-closing-comp */
/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/prop-types */
/* eslint-disable prefer-template */
/* eslint-disable react/no-danger */
import React, {Component} from 'react';
import postscribe from 'postscribe';
import request from "superagent";
import {Helmet} from "react-helmet";
import {filterHTML} from "../../helpers/filters";
import API from "../../config/API";
import './JobSingle.scss';
import ReactVideoModal from "../ReactVideoModal/ReactVideoModal";
// import {getQueryParamsAsObject} from "../../helpers/window";

class JobSingle extends Component {

    state = {
        job: {},
        job_post: {},
        splitContentVideoIsOpen: false,
    };

    componentDidMount() {
        let id = null;
        if(this.props.match.params.id.includes('-')) {
            id = this.props.match.params.id.split('-').pop();
        }

        if(!id || isNaN(id)) {
			const queryParams = new URLSearchParams(this.props.location.search);
			const jobID = queryParams.get('gh_jid');


            request.get(`${API.getHost()}/harvest.php?path=/job_posts/`).then(res => {
                if (res && res.body) {
                    const jobPosts = res.body;

                    for(let i = 0; i < jobPosts.length; i++) {
                        if(jobPosts[i].id === Number(jobID)) {
                            id = jobPosts[i].job_id;
                            this.setState({job_post: jobPosts[i]});

                            request.get(`${API.getHost()}/harvest.php?path=/jobs/${id}`).then(response => {
                                if (response && response.body) {
                                    this.setState({job: response.body});
                                }
                            });

                            break;
                        }
                    }
                }
            });
        } else {
            // Get the job post by job ID
            request.get(`${API.getHost()}/harvest.php?path=/jobs/${id}/job_post`).then(res => {
                if (res && res.body) {
                    this.setState({job_post: res.body});
                }
            });

            request.get(`${API.getHost()}/harvest.php?path=/jobs/${id}`).then(res => {
                if (res && res.body) {
                    this.setState({job: res.body});
                }
            });
        }



        const element = document.getElementById('grnhse_app');
        if(element) {
            postscribe('#jobSingle', '<script type="text/javascript" src="/public/greenhouse-embed.js"></script>');
        }
    }



    render() {
        // if (!this.state.job || !Object.keys(this.state.job).length) return null;

        const splitContentVideoUrl = 'https://vimeo.com/846024356';

        const job = this.state.job;
        let jobDetails = '';

        if(job.custom_fields && job.custom_fields.business_line) {
            jobDetails = job.custom_fields.business_line;
        }

        if(this.state.job_post.location) {
            let locationName = this.state.job_post.location.name;
            if(locationName.includes(',') && locationName.split(',').length > 2) {
                locationName = locationName.split(',')[0] + ', ' + locationName.split(',')[1];
            }
            jobDetails = jobDetails + ' | ' + locationName;
        }

        if(job.custom_fields && job.custom_fields.employment_type) {
            jobDetails = jobDetails + ' | ' + job.custom_fields.employment_type;
        }

        const live = true;
        // if(this.state.job_post &&!this.state.job_post.live) {
        //     live = false;
        // }


        return (
            <React.Fragment>
                <Helmet>
                    <title>MarketAxess</title>
                </Helmet>
                <section className="jobSingle" id="jobSingle">

                    <div className="jobSingleHero">
                        <div className="container">
                            <div className="jobSingleHero__content">
                                <a href="/careers/current-openings/" className="jobSingleHero__return">Back to Search</a>
                                <h2>{this.state.job_post.title}</h2>
                                <h3>{jobDetails}</h3>
                                {!live ? (
                                    <h3 className="jobSingleHero__unavailable">Applications have closed for this job</h3>
                                ) : null}
                            </div>
                        </div>
                    </div>

                    <div className="container" id="jobDescriptionContainer">

                        <div className="jobSingleSplitContent">
                            <h2>Company Description</h2>
                            <div className="jobSingleSplitContent__split">
                                <div className="jobSingleSplitContent__column jobSingleSplitContent__column--description">
                                    <p>
                                        MarketAxess is on a journey to digitally transform one of the world’s largest financial
                                        markets, enabling the shift from analog, phone-based trading to a fully electronic marketplace.
                                        Why does this matter? Because our platform makes trading fixed-income more accessible,
                                        ultimately improving transparency, efficiency, and competition in the marketplace.
                                        Changing the way an established industry transacts is no easy feat. There will be
                                        twists and turns, because no one’s ever done this before. But now, more than 2,000
                                        clients around the world rely on our solutions, and that number is only expected to
                                        grow in the years ahead. We know where we’re going. How we get there is up to us.
                                        Join us and help Take Us There.
                                    </p>
                                </div>
                                <div className="jobSingleSplitContent__column jobSingleSplitContent__column--video">

                                    <div className="jobSingleVideo" role="button" onClick={() => {
                                        this.setState({splitContentVideoIsOpen: !this.state.splitContentVideoIsOpen})
                                    }}>
                                        {this.state.splitContentVideoIsOpen ? (
                                            <ReactVideoModal uri={filterHTML(splitContentVideoUrl)} isOpen={this.state.splitContentVideoIsOpen} onClose={() => {
                                                this.setState({splitContentVideoIsOpen: !this.state.splitContentVideoIsOpen})
                                            }}/>
                                        ) : null}
                                        <img className="jobSingleVideo__thumbnail" src="https://assets.marketaxess.com/2023-08/What-we-do-cover.jpg" alt=""/>
                                        <div className="jobSingleVideo__play">
                                            <svg enableBackground="new 0 0 85 85" viewBox="0 0 85 85" xmlns="http://www.w3.org/2000/svg"><g fill="#fff"><path d="m42.5 0c-23.5 0-42.5 19-42.5 42.5s19 42.5 42.5 42.5 42.5-19 42.5-42.5-19-42.5-42.5-42.5zm0 77.7c-19.5 0-35.2-15.7-35.2-35.2s15.7-35.2 35.2-35.2 35.2 15.7 35.2 35.2-15.7 35.2-35.2 35.2z"/><path d="m32.1 61.6 31.5-19.1-31.5-19.1z"/></g></svg>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        {this.state.job_post && this.state.job_post.content ? (
                            <React.Fragment>
                                <div className="jobSingle__description" dangerouslySetInnerHTML={{__html: filterHTML(this.state.job_post.content)}}/>
                                {/* {this.state.job_post.live ? (*/}
                                {/*    <a href={`https://boards.greenhouse.io/marketaxesscorporation/jobs/${this.state.job_post.id}#application`} target="_blank" rel="noopener noreferrer" className="button button--ghost jobSingle__applyButton">Apply now</a>*/}
                                {/* ) : null}*/}
                            </React.Fragment>
                        ) : null}
                    </div>

                    {live ? (
                        <div className="jobSingle__application container">
                            <div id="grnhse_app"></div>
                        </div>
                    ) : (
                        <div className="container jobUnavailable__container">
                            <h3>This job application is no longer available</h3>
                        </div>
                    )}

                </section>

            </React.Fragment>
        )
    }
}

export default JobSingle;



// WEBPACK FOOTER //
// ./frontend/components/JobSingle/JobSingle.jsx